import { Box, Stack } from '@mui/material'
import { Divider, Typography } from 'antd'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface NotificationProps {
  isLegacyShown: boolean
  legacyBannerHeight?: number
  index: number
  content: string
  icon?: string
  severity: 'INFO' | 'WARN' | 'ALARM'
}

const colorMap = {
  INFO: '#4169E1',
  WARN: '#E5A830',
  ALARM: '#DF5664',
}

export function Notification({
  content,
  icon,
  index,
  isLegacyShown,
  legacyBannerHeight = 0,
  severity,
}: NotificationProps) {
  return (
    <Box
      sx={{
        width: '100%',
        position: 'fixed',
        top: (isLegacyShown ? legacyBannerHeight : 0) + index * 56,
        height: '56px',
        minHeight: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        zIndex: 1250,
        bgcolor: colorMap[severity],
        paddingLeft: '16px',
        paddingRight: '16px',
        py: '8px',
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center" direction="row" gap="8px">
        {!!icon && (
          <img alt="Иконка уведомления" height={24} src={icon} width={24} />
        )}
        <Stack alignItems="center" direction="row" gap="8px">
          <Markdown
            components={{
              h1(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Title
                    level={1}
                    style={{ margin: '0 ', color: 'white' }}
                    {...rest}
                  />
                )
              },
              h2(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Title
                    level={2}
                    style={{ margin: '0 ', color: 'white' }}
                    {...rest}
                  />
                )
              },
              h3(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Title
                    level={3}
                    style={{ margin: '0 ', color: 'white' }}
                    {...rest}
                  />
                )
              },
              h4(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Title
                    level={4}
                    style={{ margin: '0 ', color: 'white' }}
                    {...rest}
                  />
                )
              },
              h5(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Title
                    level={5}
                    style={{ margin: '0 ', color: 'white' }}
                    {...rest}
                  />
                )
              },
              p(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Paragraph
                    style={{ margin: '0', color: 'white' }}
                    {...rest}
                  />
                )
              },
              a(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Link
                    rel="noopener noreferrer"
                    style={{
                      margin: '0 ',
                      color: 'white',
                      textDecoration: 'underline',
                    }}
                    target="_blank"
                    {...rest}
                  />
                )
              },
              ul(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Paragraph
                    style={{ margin: '0 ', color: 'white' }}
                  >
                    <ul {...rest}></ul>
                  </Typography.Paragraph>
                )
              },
              hr(props) {
                const { node, ...rest } = props

                return <Divider {...rest} />
              },
              blockquote(props) {
                const { node, ...rest } = props

                return (
                  <Typography.Paragraph
                    style={{ margin: '0 ', color: 'white' }}
                  >
                    <blockquote {...rest} />
                  </Typography.Paragraph>
                )
              },
            }}
            remarkPlugins={[remarkGfm]}
          >
            {content}
          </Markdown>
        </Stack>
      </Stack>
    </Box>
  )
}
